import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import PriceRecommendationStateDriver from '@app/model/market_state/PriceRecommendationStateDriver';
import PriceRecommendationRoomState from '@app/model/market_state/PriceRecommendationRoomState';

export class PriceRecommendationState {
	id: number
	requestId: number
	companyHotelId: number
	architectureId: number
	statDate: string
	roomMappingType: HotelRoomMappingType
	creationDate: string
	recommendedChangeRate: number
	effectiveChangeRate: number
	confidence: number
	narrative: string
	priceRuleLimited: boolean
	driversExplanation: string
	drivers: PriceRecommendationStateDriver[]
	isValid: boolean
	direction: string
	minimumBasePriceRoomStates: PriceRecommendationRoomState[]
	marketStatePromptId: number

	constructor(data: PriceRecommendationState) {
		Object.assign(this, data);
	}

	findLowestPriceLogRoom() {
		if (this.minimumBasePriceRoomStates.length === 0) return undefined;
		return this.minimumBasePriceRoomStates.reduce((a, b) => a.basePrice < b.basePrice || (a.basePrice === b.basePrice && a.isAnchor) ? a : b);
	}

	findLowestPriceForAnchorLogRoom() {
		const anchorRoomStates = this.minimumBasePriceRoomStates.filter(r => r.isAnchor);
		if (anchorRoomStates.length === 0) return undefined;
		return anchorRoomStates.reduce((a, b) => a.basePrice < b.basePrice ? a : b);
	}

	findDistinctDerivativeRoomsWithLowestPrice(): PriceRecommendationRoomState[] {
		const lowestByRoomId = new Map<number, PriceRecommendationRoomState>();
		for (const room of this.minimumBasePriceRoomStates) {
			if (!room.isDerivative) continue;
			const existing = lowestByRoomId.get(room.roomId);
			if (!existing || room.basePrice < existing.basePrice) {
				lowestByRoomId.set(room.roomId, room);
			}
		}
		return Array.from(lowestByRoomId.values());
	}

	findLowestPriceForLogRoom(roomId: number) {
		return this.minimumBasePriceRoomStates.find(r => r.roomId === roomId);
	}
}
